var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorSphere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.096,
    height: 31.096,
    viewBox: "0 0 31.096 31.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e76d10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7ac4c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M17.669,13.308v2.12a.707.707,0,0,0,1.148.552l3.34-2.672h1.165A5.654,5.654,0,0,0,23.323,2H17.669A5.654,5.654,0,0,0,17.669,13.308Z",
    transform: "translate(-2.948)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M33.308,19H27.654a5.654,5.654,0,1,0,0,11.308h1.165l3.34,2.672a.712.712,0,0,0,1.148-.552v-2.12a5.654,5.654,0,0,0,0-11.308Z",
    transform: "translate(-5.866 -4.986)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M5.062,23.7A4.945,4.945,0,1,0,9.946,18a4.972,4.972,0,0,0-4.884,5.7Z",
    transform: "translate(-0.879 -4.692)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M2.707,41.854H15.428a.707.707,0,0,0,.707-.707V37.614a7.06,7.06,0,0,0-2.963-5.749,6.4,6.4,0,0,1-8.208,0A7.06,7.06,0,0,0,2,37.614v3.534a.707.707,0,0,0,.707.707Z",
    transform: "translate(0 -8.759)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorSphere);
export default __webpack_public_path__ + "static/media/mentorSphere.900962223199f2d9d7bce92d51d00c90.svg";
export { ForwardRef as ReactComponent };